import { queryClient } from 'v4/migration/queryClientSingleton';
import { myAvailabilityRequestApi } from 'v5/api/availability-request/availability-request.api.connected';
import { myErrorService } from 'v5/services/front/ErrorService/ErrorService.connected';
import { createAvailabilityRequestService } from './AvailabilityRequestService.impl';

export const myAvailabilityRequestService = createAvailabilityRequestService({
  api: myAvailabilityRequestApi,
  queryClient,
  services: {
    errorService: myErrorService
  }
});
